import { render, staticRenderFns } from "./AttentionDot.vue?vue&type=template&id=1ba24668&scoped=true&"
import script from "./AttentionDot.vue?vue&type=script&lang=ts&"
export * from "./AttentionDot.vue?vue&type=script&lang=ts&"
import style0 from "./AttentionDot.vue?vue&type=style&index=0&id=1ba24668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba24668",
  null
  
)

export default component.exports